import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { CommonModule, DatePipe } from "@angular/common";
import { Table, TableLazyLoadEvent, TableModule } from "primeng/table";
import { VerifyClientList } from "../../../../core/models/client/verify/verifyClientList";
import { ClientList } from "../../../../core/models/client/clientList";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { LoaderService } from "../../../../core/services/loader.service";
// import { SidebarService } from "../../../../core/services/sidebar.service";
import { SharedService } from "../../../../core/services/shared.service";
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ClientDetailsComponent } from "../client-details/client-details.component";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { DateFilter } from "../../../../core/models/common/date-filter-request.dto";
import { CardModule } from "primeng/card";
import { RadioButtonClickEvent, RadioButtonModule } from "primeng/radiobutton";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { Subject } from "rxjs";
import { GenericClientRequestDto } from "../../../../core/models/client/genericClientRequestDto";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericSortRequestDto } from "../../../../core/models/generic-sort-request.dto";
import { FilterMetadata } from "primeng/api";
import { CalendarModule } from "primeng/calendar";

@UntilDestroy()
@Component({
  selector: "jni-clients-listing",
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    CheckboxModule,
    DateFilterComponent,
    FormsModule,
    ModalStackerComponent,
    ClientDetailsComponent,
    CardModule,
    RadioButtonModule,
    ButtonModule,
    InputTextModule,
    SpinnerComponent,
    CalendarModule,
  ],
  templateUrl: "./clients-listing.component.html",
  styleUrls: ["./clients-listing.component.scss"],
})
export class ClientsListingComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("dt") table!: Table;
  @Input() expiringDayFromModal = "";
  @Input() clientStatus = "";
  @Output() scrollHiddenStatus = new EventEmitter();

  selectedRadioButton = "All";
  clientListings: VerifyClientList[] = [];
  filterClientList: VerifyClientList[] = [];
  filterClientAllDataList: VerifyClientList[] = [];
  checkboxStatus = 0;
  selectedClients: ClientList[] = [];
  expiringDays = "";

  heading = "Clients";
  newHeading = "Client List";
  showSmallLoader = false;
  clientDisplayModal = false;
  clientDisplayModalStatus = false;
  clientId = "";
  organizationNameCharacterCond = false;
  lastOrderDateColumn = "lastOrderDate";
  lastOrderDateFilterApplied = false;

  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;
  lazyLoadEvent: TableLazyLoadEvent = {};
  defaultTake = 50;
  totalRecords = 0;
  filterTextChanged: Subject<Event> = new Subject<Event>();
  filterDebounceTime = 1000;
  constructor(
    public router: ActivatedRoute,
    public route: Router,
    public _loaderService: LoaderService,
    public _clientsListingService: ClientsListingService,
    private renderer: Renderer2,
    // private _sidebarService: SidebarService,
    private _sharedService: SharedService,
    public _datePipe: DatePipe
  ) {
    this.router.params.subscribe((params: Params) => {
      this.clientStatus = params["id"];
      this.expiringDays = params["type"];
      if (typeof this.expiringDays === "string") {
        this.newHeading = "";
        this.newHeading = `${this.heading} with 30 days or less protection remaining`;
      }
      this.closeModalOnClient();
    });
  }

  ngOnInit() {
    //this.getClientData();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  closeModalOnClient() {
    // this._sidebarService.selectedMenu$.subscribe((value) => {
    //   if (value && value?.includes('clients')) {
    //     this.clientDisplayModal = false;
    //   }
    // });
  }

  ngOnChanges() {
    if (this.expiringDayFromModal) {
      this.expiringDays = this.expiringDayFromModal;
      if (typeof this.expiringDays === "string") {
        this.newHeading = "";
        this.newHeading = `${this.heading} with 30 days or less protection remaining`;
      }
      this.clientDisplayModalStatus = true;
      //this.ngOnInit();
    }
  }

  onClientRedirection() {
    const url = `/clients/active/verify-client`;
    this.route.navigate([url]);
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  checkboxSelection() {
    const count = this.clientListings.filter(
      obj => obj.isActive == true
    ).length;
    if (count > 1 || count == 0) {
      this._clientsListingService.setAttachmentState(true);
    } else {
      this._clientsListingService.setAttachmentState(false);
    }
  }

  // getClientData() {
  //   if (this.clientStatus) {
  //     if (this.expiringDays) {
  //       this.getClientListUnprotectedDays();
  //     } else {
  //       this.getClientListData();
  //     }
  //   }
  // }

  // getClientListData() {
  //   this.showSmallLoader = true;
  //   this._clientsListingService
  //     .getClientList("Submitted")
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res: GenericResponseDto<VerifyClientList[]>) => {
  //         this.clientListings = res.data;
  //         this.filterClientList = this.clientListings;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       },
  //     });
  // }

  // getClientListUnprotectedDays() {
  //   this.showSmallLoader = true;
  //   this._clientsListingService
  //     .getClientListUnprotectedDays("Submitted", "0")
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res: GenericResponseDto<VerifyClientList[]>) => {
  //         this.clientListings = res.data;
  //         this.filterClientList = this.clientListings;
  //         this.showSmallLoader = false;
  //       },
  //       error: () => {
  //         this.showSmallLoader = false;
  //       },
  //     });
  // }

  redirectToSummaryPage(accountNumber: string) {
    if (accountNumber) {
      this.clientId = accountNumber;
      this.clientDisplayModal = true;
    }
    // const url =
    //   `/clients/${this.clientStatus}/client-details/` +
    //   accountNumber.toString();
    // this.route.navigate([url]);
  }

  exportExcel() {
    // this.showSmallLoader = true;
    // this.filterClientList.length = 0;
    // this.clientListings.forEach((ele) => {
    //   if (ele.isActive) {
    //     this.checkboxStatus = 1;
    //     this.filterClientList.push(ele);
    //   }
    // });
    // if (this.checkboxStatus == 1) {
    //   this.exportExcelForFilterData(this.filterClientList);
    //   this.showSmallLoader = false;
    // } else {
    //   this.exportExcelForFilterData(this.clientListings);
    //   this.showSmallLoader = false;
    // }
    this.showSmallLoader = true;
    this.exportExcelForFilterData(this.filterClientList);
    this.showSmallLoader = false;
  }

  exportExcelForFilterData(filterclientlist: VerifyClientList[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Account"]: datum.customerAccount,
        ["Name"]: datum.organizationNameD365,
        ["Available Credit"]: datum.revisedCreditLimitD365,
        ["Address"]: datum.clientPrimaryAddress,
        ["Contact"]: datum.primaryContactName,
        ["Branding Consultant"]: datum.brandingconsultant,
        ["Safe Days"]: datum.protectionNumber,
        ["Billing Rep"]: datum.billingRepD365,
        ["Last Order"]: datum.lastOrderDate,
        // ['Email']: datum.primaryContactEmail,
        // ['Contact Number']: datum.primaryContactNumber,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ClientList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  addScollHiddenClass() {
    if (this.clientDisplayModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    } else {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  redirectToOrderListingPage(accountNumber: string) {
    if (accountNumber) {
      const objData = this.setOrdersAdditionalFilters(accountNumber);
      objData.status = "ALL";
      this._sharedService.setDashbaordPocAdditionalFiltersObject(objData);
      this.route.navigate(["orders/orderslist/1"]);
    }
  }

  setOrdersAdditionalFilters(accountNumber: string) {
    const dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters = {
      customerAccountNumber: accountNumber,
      additionalFilters: true,
    } as DashbaordPocAdditionalFilters;
    return dashbaordPocAdditionalFilters;
  }

  organizationNameCharacterCount(obj: string) {
    if (obj && obj?.length > 40) this.organizationNameCharacterCond = true;
  }

  clearFilter(event: VerifyClientList[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterClientList = event;
      this.lastOrderDateFilterApplied = false;
    }
  }

  applyFilter(event: VerifyClientList[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterClientList = event;
      this.lastOrderDateFilterApplied = true;
    }
  }

  // onFilter(event: TableFilterEvent) {
  //   if (event.filters) {
  //     this.filterClientListExport = event.filteredValue;
  //   } else if (!this.lastOrderDateFilterApplied) {
  //     this.filterClientListExport = this.filterClientList;
  //   }
  // }

  getClientFilterOnChange(event: RadioButtonClickEvent) {
    const value = event.value;
    this.showSmallLoader = true;
    if (value == "OrdersYes") {
      this.filterClientList = this.clientListings.filter(
        x =>
          x.lastOrderDate !== null &&
          x.lastOrderDate !== undefined &&
          !x.lastOrderDate?.includes("1900") &&
          x.lastOrderDate !== ""
      );
    } else if (value == "OrdersNo") {
      this.filterClientList = this.clientListings.filter(
        x =>
          x.lastOrderDate === null ||
          x.lastOrderDate === undefined ||
          x.lastOrderDate?.includes("1900") ||
          x.lastOrderDate === ""
      );
    } else if (value == "NoAvailCredit") {
      this.filterClientList = this.clientListings.filter(
        x => x.availableCredit <= 0
      );
    } else if (value == "NoProtection") {
      this.filterClientList = this.clientListings.filter(
        x =>
          x.protectionNumber === -1 ||
          x.protectionNumber === 0 ||
          x.protectionNumber === null ||
          x.protectionNumber === undefined
      );
    } else {
      this.filterClientList = this.clientListings;
    }
    this.showSmallLoader = false;
  }

  getClientsList(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    this._loaderService.setLoaderState(true);
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const filterValue = event?.filters?.[x] as FilterMetadata;
      return {
        columnName: x || "",
        matchMode: filterValue.matchMode ?? "",
        tableName: "clients",
        value: filterValue.value == null ? "" : (filterValue.value ?? ""),
      } as GenericFilterRequestDto;
    });
    filter.forEach(x => {
      if (x.columnName === "clientPrimaryAddress") {
        x.columnName = "ClientAddress";
        x.tableName = "Address";
      }
      if (x.columnName === "lastOrderDate") {
        x.columnName = "LastOrderDate";
        x.tableName = "Orders";
        x.value =
          this._datePipe.transform(x.value, "yyyy-MM-dd HH:mm:ss.SSS") ??
          x.value;
      }
    });
    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];
    sortArray.forEach(x => {
      if (x.field === "availableCredit") {
        x.field = "AvailableD365";
      }
    });
    const expingDays = parseInt(this.expiringDays ?? 0);
    const request: GenericClientRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
      unprotectedDays: expingDays,
    };
    this._clientsListingService
      .getClientListing(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<VerifyClientList[]>) => {
          this.totalRecords = res.totalRecords ?? 0;
          this.clientListings = res.data;

          if (expingDays === 1) {
            this.clientListings = res.data.sort((a, b) => {
              // Handle null/undefined values - put them at the end
              if (a.protectionNumber == null && b.protectionNumber == null)
                return 0;
              if (a.protectionNumber == null) return 1;
              if (b.protectionNumber == null) return -1;

              return a.protectionNumber - b.protectionNumber;
            });
          }

          this.filterClientList = this.clientListings;
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }
}
